import Cookies from 'js-cookie';

const SESSION_COOKIE = 'session_state';

export type SessionState = 'logged_in' | 'logged_out' | 'unknown';

export const getSessionStateFromCookie = (): SessionState => {
  return (Cookies.get(SESSION_COOKIE) as SessionState) || 'unknown';
};

export const setSessionStateCookie = (
  value: SessionState,
  expiresMinutes = 13,
) => {
  Cookies.set(SESSION_COOKIE, value, {
    expires: expiresMinutes / (24 * 60),
    sameSite: 'lax',
  });
};

export const clearSessionStateCookie = () => {
  Cookies.remove(SESSION_COOKIE);
};
